// import { get } from "lodash";

export default {
  getMentorRating: (state) => state.mentorRating,
};
